<template>
  <div class="settings">
    <h1>
      {{ $t("langcfg.txtDateFormat") }}
    </h1>
    <div style="margin-top: 30px">
      <div style="margin-top: 5px" v-for="item in dataFormats" :key="item.key">
        <el-radio-group v-model="dateFormat" text-color="#00ff00" @change="selectItem">
          <el-radio :label="item.key" text-color="#00ff00">{{ item.label }}</el-radio>
        </el-radio-group>
      </div>
    </div>
  </div>
</template>
<script>
import { saveSettings } from "../../../settings";
import { DATEFORMATS, _DATEFORMATS } from "../../../shared/consts";
import { mapActions, mapGetters, mapState } from "vuex";
import EVENTS from "../../../bus";
import home from "../../../store/modules/home";
const { ipcRenderer } = window.require("electron");
export default {
  name: "DateFormat",
  data() {
    return {
      dateFormat: "yyyymmdd_line",
      dataFormats: []
    };
  },
  computed: {
    ...mapState({
      isHasUrl: (state) => home.state.isHasUrl
    })
  },
  methods: {
    ...mapActions({
      dateFormatChanged: "home/dateFormatChanged"
    }),
    selectItem() {
      window.settings.dateFormat = this.dateFormat;
      this.dateFormatChanged(_DATEFORMATS[this.dateFormat].label);
      saveSettings(window.settings);
      // /
      this.sendChangeStatus(this.dateFormat, _DATEFORMATS[this.dateFormat].label);
    },
    sendChangeStatus(dateFormat, label) {
      // /
      let send = null;
      if (this.isHasUrl) {
        send = "sendSetMsg2";
      } else {
        send = "sendSetMsg";
      }
      ipcRenderer.send(send, {
        type: "setMainFaceDateFrom",
        dateFormat: dateFormat,
        label: label
      });
    },
    // /
    watchSetStatus() {
      let _this = this;
      this.$bus.$on(EVENTS.setDateFrom, function (msg) {
        window.settings.dateFormat = msg.dateFormat;
        _this.dateFormatChanged(msg.label);
        _this.dateFormat = msg.dateFormat;
        saveSettings(window.settings);
      });
    }
  },
  created() {
    this.dataFormats = DATEFORMATS.filter((item) => {
      return item.visible;
    });
    this.dateFormat = window.settings.dateFormat;
  },
  mounted() {
    this.watchSetStatus();
  },
  beforeDestroy() {
    this.$bus.$off(EVENTS.setDateFrom);
  }
};
</script>
<style lang="less" scoped>
.settings {
  margin-top: 60px;
  margin-left: 60px;
  font-size: 23px;
  color: white;
  display: flex;
  align-items: left;
  flex-direction: column;
}
.logo-img {
  width: 350px;
}
.el-radio {
  height: 80px;
  line-height: 80px;
  padding: 0 20px;
}
.el-radio /deep/ .el-radio__input {
  vertical-align: -5px !important;
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/settings/DateFormat.vue